<template>
  <div>
    <custom-actions show-back>
      <el-steps align-center :active="activeStep" finish-status="success" class="steps">
        <el-step title="新增用印申请"></el-step>
        <el-step title="新增用印文件"></el-step>
      </el-steps>

      <!-- 第一步：新增用印申请 -->
      <el-form v-if="activeStep === 0" class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="applyTitle" label="申请标题">
              <el-input v-model="formData.applyTitle" placeholder="请输入申请标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="useDesc" label="用印事由描述">
              <el-input type="textarea" v-model="formData.useDesc" placeholder="请输入用印事由描述" rows="4"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="userId" label="签章人">
              <el-select v-model="formData.userId" :disabled="true" clearable filterable placeholder="请选择签章人">
                <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sealId" label="印章">
              <el-select v-model="formData.sealId" @change="onSealIdChange" clearable filterable multiple placeholder="请选择印章">
                <el-option v-for="(item, index) of sealList" :value="item.id" :label="item.name" :key="index"></el-option>
              </el-select>
              <!-- <div class="tips">注：可多选，多个印章id将以逗号分隔</div> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button type="primary" @click="nextStep">下一步</el-button>
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 第二步：新增用印文件 -->
      <el-form v-if="activeStep === 1" class="global-form shoufa-form" :model="fileForm" :rules="fileRules" ref="fileForm" label-width="130px" v-loading="loading">
        <el-row>
          <el-col :span="24">
            <el-form-item label="用印文件">
              <el-upload
                class="upload-demo"
                :action="'/v2/document/addbyfile'"
                :auto-upload="false"
                :headers="qysHeaders"
                :on-change="handleFileChange"
                :on-remove="handleFileRemove"
                :file-list="fileList"
                :limit="10"
                multiple
              >
                <el-button size="small" type="primary">点击选择</el-button>
                <div slot="tip" class="el-upload__tip">请选择要上传的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="prevStep">上一步</el-button>
              <el-button type="primary" @click="submitForm">保存</el-button>
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'SealApplyAdd',
  data() {
    return {
      activeStep: 0,
      applyId: '',
      qysHeaders: {},
      formData: {
        applyTitle: '',
        useDesc: '',
        userId: '20250410102609163188',
        sealId: [],
        sealName: []
      },
      fileForm: {
        title: '',
        fileSuffix: ''
      },
      fileList: [],
      fileFormList: [],
      userList: [],
      sealList: [],
      loading: false,
      rules: {
        applyTitle: [
          {
            required: true,
            message: '请输入申请标题',
            trigger: ['blur', 'change']
          }
        ],
        useDesc: [
          {
            required: true,
            message: '请输入用印事由描述',
            trigger: ['blur', 'change']
          }
        ],
        userId: [
          {
            required: true,
            message: '请选择签章人',
            trigger: ['blur', 'change']
          }
        ],
        sealId: [
          {
            required: true,
            message: '请选择印章',
            trigger: ['blur', 'change']
          }
        ]
      },
      fileRules: {
        title: [
          {
            required: true,
            message: '请输入文件名称',
            trigger: ['blur', 'change']
          }
        ],
        fileSuffix: [
          {
            required: true,
            message: '请输入文件后缀',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  created() {
    this.loadQysHeaders()
    this.loadUserList()
  },
  methods: {
    // 获取契约锁请求头参数
    loadQysHeaders() {
      this.$axios.get(this.$apis.sealApply.selectqiyuesuo).then(res => {
        this.qysHeaders = {
          'x-qys-open-accesstoken': res['x-qys-open-accesstoken'],
          'x-qys-open-signature': res['x-qys-open-signature'],
          'x-qys-open-timestamp': res['x-qys-open-timestamp'],
          'x-qys-open-nonce': res['x-qys-open-nonce']
        }
        // 获取到请求头后再加载印章列表
        this.loadSealList()
      })
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '1',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list || []
      })
    },
    loadSealList() {
      // 调用契约锁印章列表接口
      this.$axios.get('/v2/seal/list', {
        selectOffset: 0,
        selectLimit: 1000
      }, {
        headers: this.qysHeaders
      }).then(sealRes => {
        console.log('sealRes', sealRes)
        if (sealRes.responseCode === '00000000') {
          this.sealList = sealRes.result.list || []
        } else {
          this.$message.error('获取印章列表失败：' + sealRes.message)
        }
      })
    },
    nextStep() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.activeStep = 1
        }
      })
    },
    prevStep() {
      this.activeStep = 0
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList
      // 从 fileFormList 中移除对应的文件
      const index = this.fileFormList.findIndex(item => item.title === file.name)
      if (index !== -1) {
        this.fileFormList.splice(index, 1)
      }
    },
    onSealIdChange(value) {
      const selectedSeals = this.sealList.filter(seal => value.includes(seal.id))
      this.formData.sealName = selectedSeals.map(seal => seal.name)
      console.log('this.formData.sealName', this.formData.sealName)
    },
    // 添加上传到 fileFormList
    addToFileFormList(documentId, index) {
      if (index !== undefined && this.fileList[index]) {
        const file = this.fileList[index]
        this.fileFormList.push({
          applyId: this.applyId,
          documentId: documentId || this.getDocumentId(),
          title: file.name.split('.')[0],
          fileSuffix: file.name.split('.').pop()
        })
      } else {
        this.fileList.forEach(file => {
          this.fileFormList.push({
            applyId: this.applyId,
            documentId: documentId || this.getDocumentId(),
            title: file.name,
            fileSuffix: file.name.split('.').pop()
          })
        })
      }
    },
    // 模拟获取文件ID的方法
    getDocumentId() {
      // 实际项目中需要调用第三方接口获取文件ID
      return 'doc_' + Date.now()
    },
    submitForm() {
      this.$refs.fileForm.validate((valid) => {
        if (valid) {
          if (this.fileList.length === 0) {
            this.$message.warning('请至少上传一个签章文件')
            return
          }
          this.loading = true
          // 第一步：新增用印申请
          const applyFormData = {
            ...this.formData,
            sealId: this.formData.sealId.join(','),
            sealName: this.formData.sealName.join(',')
          }
          this.$axios.post(this.$apis.sealApply.insertSealApply, applyFormData).then(res => {
            this.applyId = res
            // 第二步：上传文件到契约锁
            return this.uploadFile()
          }).then(documentIds => {
            // 清空之前的文件表单列表
            this.fileFormList = []
            // 添加到文件表单列表
            if (Array.isArray(documentIds)) {
              documentIds.forEach((documentId, index) => {
                this.addToFileFormList(documentId, index)
              })
            } else {
              this.addToFileFormList(documentIds || this.getDocumentId())
            }
            // 第三步：新增用印文件
            return this.$axios.post(this.$apis.sealApply.insertAllSealFile, this.fileFormList)
          }).then(() => {
            // this.$message.success('新增成功')
            this.$router.push('/sealApply/list')
          }).catch(error => {
            this.$message.error('操作失败：' + error.message)
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 文件上传到契约锁
    uploadFile() {
      return new Promise((resolve, reject) => {
        console.log(this.fileList)
        if (this.fileList.length === 0) {
          resolve()
          return
        }

        // 由于需要上传多个文件，这里使用 Promise.all 来处理
        const uploadPromises = this.fileList.map(file => {
          // eslint-disable-next-line promise/param-names
          return new Promise((fileResolve, fileReject) => {
            const headers = {
              Accept: '*/*',
              'Content-Type': 'multipart/form-data;charset=UTF-8'
            }

            const formData = new FormData()
            formData.append('applyId', this.applyId) // 假设 applyId 作为 contractId
            formData.append('file', file.raw)

            // 调用契约锁文件上传接口
            this.$axios.post(this.$apis.sealApply.addDocumentByFile, formData, {
              headers: headers
            }).then(fileRes => {
              fileResolve(fileRes)
            }).catch(error => {
              fileReject(error)
            })
          })
        })

        Promise.all(uploadPromises).then(documentIds => {
          resolve(documentIds)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  text-align: center;
}
.tips {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}
.steps {
  margin-bottom: 30px;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
</style>
